export const plural = (number, word) => number === 1 ? word : `${word}s`